import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 3 años sin poder controlar el antojo de las tardes. Probé de todo — apps, dietas, suplementos. Con estas recetas llevo 6 semanas sin romper mi plan. El bowl de cacao con plátano literalmente me salvó de tirarme encima del helado tres veces esta semana.',
  name: 'María L.',
  location: 'Texas'
}, {
  quote: 'Pensé que era falta de voluntad. Llevaba años culpándome. Resulta que solo necesitaba el snack correcto. El aguacate con tajín cambió mi relación con la comida. Suena exagerado, pero es verdad.',
  name: 'Carolina R.',
  location: 'Miami'
}, {
  quote: 'Trabajo desde casa con 3 hijos. El antojo de las tardes era mi peor enemigo. Ahora en 10 minutos tengo mi snack listo, el antojo desaparece, y mis hijos también los comen con gusto. Win total.',
  name: 'Alejandra M.',
  location: 'Chicago'
}, {
  quote: 'Llevo 4 semanas usando el plan de 7 días. Bajé 6 libras sin contar calorías ni hacer dieta. Solo reemplacé mis snacks de siempre por estos. No puedo creer que sea tan fácil.',
  name: 'Gabriela T.',
  location: 'Houston'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-brand-cream text-brand-darkText" data-id="element-264">
      <div className="max-w-6xl mx-auto" data-id="element-265">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark mb-4" data-id="element-267">
            Resultados Reales
          </h2>
          <p className="text-xl text-brand-dark/70" data-id="element-268">
            Mujeres que ya apagaron sus antojos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-269">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-l-brand-medium border-y border-r border-brand-light/10 relative" data-id="element-270">
              <div className="flex gap-1 mb-6" data-id="element-271">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-272" />)}
              </div>

              <p className="text-brand-dark/80 italic mb-8 text-lg leading-relaxed" data-id="element-273">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-274">
                <div className="w-10 h-10 rounded-full bg-brand-light/20 flex items-center justify-center text-brand-dark font-bold" data-id="element-275">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-276">
                  <p className="font-bold text-brand-dark" data-id="element-277">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-brand-dark/60" data-id="element-278">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}